import { Box, Typography } from '@mui/material'
import WavesImg from 'assets/icons/Waves.svg'
import { SvgImage, Text } from 'components'
import { color } from 'config/color'
import { Center, Container } from './styles'
const SystemUnderMaintenance: React.FC = () => {
  return (
    <Container>
      <Center>
        <SvgImage name="NoDataIcon" width={100} height={100} />
        <Text fontSize="24px" fontWeight="600" color={color.black}>
          System Under Maintenance
        </Text>
        <Box width="50%">
          <Text fontSize="18x" color={color.grey[900]} align="center">
            The WEBCare Portal is currently down for maintenance. Thank you for your patience.
          </Text>
        </Box>
        <Box display="flex" flexDirection="column" gap="5px">
          <Typography
            align="center"
            textTransform="uppercase"
            color={color.grey[900]}
            fontSize="12px"
          >
            Reach us at
          </Typography>
          <Box display="flex" gap="5px" alignSelf="center">
            <Text color={color.black} fontWeight="600" fontSize="16px">
              Customer Service:
            </Text>
            <Typography color={color.background[900]} >(297) 280-4600</Typography>
          </Box>
          <Box display="flex" gap="5px" alignSelf="center">
            <Text color={color.black} fontWeight="600" fontSize="16px">
              Email:
            </Text>
            <Text color={color.background[900]} >info@webaruba.com</Text>
          </Box>
        </Box>
      </Center >
      <Box component="img" src={WavesImg} alt="background" />
    </Container >
  )
}

export default SystemUnderMaintenance
